import banks from '@/api/banks'

export default () => ({
  namespaced: true,

  state: {
    list: [],
    contracts: {}
  },

  actions: {
    fetch (context) {
      return banks.list()
        .then(data => context.commit('fetch', data))
    },
    fetchContracts ({ commit, dispatch, state }, { id, cached = true }) {
      if (cached && state.contracts[id]) {
        return Promise.resolve(state.contracts[id])
      }
      return banks.fetchContracts(id)
        .then(response => {
          commit('setContracts', { id, contracts: response.data })
          return response.data
        })
    }
  },

  mutations: {
    fetch (state, data) {
      data = data.banks
      data.forEach(entry => { entry.id = String(entry.id) })
      state.list = data
    },
    setContracts (state, { id, contracts }) {
      state.contracts = {
        ...state.contracts,
        [id]: contracts
      }
    }
  },

  getters: {
    getById: ({ list }) => (id) => {
      return list.find(bank => bank.id === id)
    },
    getContractsByBank: ({ contracts }) => id => contracts[id]
  }
})
